module.exports = __webpack_public_path__ + "img/ic-map-marker.6fe3543b.svg";